"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSiteModerationScoped = void 0;
function isSiteModerationScoped(moderationScopes) {
    const scopeSites = (moderationScopes === null || moderationScopes === void 0 ? void 0 : moderationScopes.siteIDs) || (moderationScopes === null || moderationScopes === void 0 ? void 0 : moderationScopes.sites);
    return (moderationScopes === null || moderationScopes === void 0 ? void 0 : moderationScopes.scoped) || (!!scopeSites && scopeSites.length > 0);
}
exports.isSiteModerationScoped = isSiteModerationScoped;
